import { useTranslation } from 'react-i18next';

interface PopularPlacesProps {
  onPlaceSelect: (lat: number, lng: number, city: string, country?: string) => void;
}

const POPULAR_PLACES = [
  // Hlavní město Dhaka a čtvrti
  { name: 'Dhaka', lat: 23.8103, lng: 90.4125, country: 'Bangladesh' },
  { name: 'Dhanmondi', lat: 23.7465, lng: 90.3713, country: 'Bangladesh' },
  { name: 'Gulshan', lat: 23.7806, lng: 90.4192, country: 'Bangladesh' },
  { name: 'Banani', lat: 23.7949, lng: 90.4054, country: 'Bangladesh' },
  { name: 'Uttara', lat: 23.8759, lng: 90.3795, country: 'Bangladesh' },
  { name: 'Mirpur', lat: 23.8069, lng: 90.3687, country: 'Bangladesh' },
  { name: 'Motijheel', lat: 23.7299, lng: 90.4192, country: 'Bangladesh' },
  { name: 'Old Dhaka', lat: 23.7104, lng: 90.4074, country: 'Bangladesh' },
  { name: 'Baridhara', lat: 23.7874, lng: 90.4207, country: 'Bangladesh' },
  // Další města v Bangladéši
  { name: 'Chittagong', lat: 22.3569, lng: 91.7832, country: 'Bangladesh' },
  { name: 'Sylhet', lat: 24.8949, lng: 91.8690, country: 'Bangladesh' },
  { name: 'Rajshahi', lat: 24.3745, lng: 88.6042, country: 'Bangladesh' },
  { name: 'Khulna', lat: 22.8456, lng: 89.5403, country: 'Bangladesh' },
];

export function PopularPlaces({ onPlaceSelect }: PopularPlacesProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-4">
      <h3 className="text-sm font-semibold text-boho-cream mb-3">{t('search.popularPlaces')}</h3>
      <div className="flex gap-2 overflow-x-auto lg:overflow-x-visible lg:flex-wrap pb-2 scrollbar-hide">
        {POPULAR_PLACES.map((place) => (
          <button
            key={place.name}
            onClick={() => onPlaceSelect(place.lat, place.lng, place.name, t(`countries.${place.country}`))}
            className="flex-shrink-0 px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap text-boho-cream bg-white/10 border border-white/20 hover:bg-white/15 hover:border-white/30"
          >
            {place.name}
          </button>
        ))}
      </div>
    </div>
  );
}

